<template>
  <div class="container main">
    <div class="container text texto-intro m-y-2-lg m-y-1-sm">
      <h1>Diagnóstico</h1>
      <p class="intro">
        La incidencia del conocimiento humanístico, científico y tecnológico es
        fundamental para comprender, visibilizar y atender los proyectos
        prioritarios del país. La presente sección pone a disposición pública
        las aportaciones producto del diálogo y la vinculación entre diversos
        actores de la academia, el sector público y organizaciones comunitarias
        para coadyuvar al Proyecto Prioritario Rescate del Lago de Texcoco.
      </p>
    </div>

    <div class="container">
      <div class="grid-descargas m-t-1 m-t-3-md m-b-2-md">
        <LinkPDF
          class="m-b-1"
          link="diagnostico_docs/DRNOCM_VERSIÓN EXTENSA_ENI_2021.pdf"
          descripcion="Diagnóstico científico y recomendaciones para la restauración socioambiental de la región impactada por el proyecto Nuevo Aeropuerto de la Ciudad de México"
          nombre="Diagnóstico científico"
          peso="PDF 20.4 MB"
          imagen_lap="diagnostico_docs/diagnostico.webp"
          imagen_cel="diagnostico_docs/diagnostico.webp"
          :descargable="false"
        />
        <LinkPDF
          class="m-b-1"
          link="https://conacytmx.sharepoint.com/:b:/s/ARLT/ERamamoS2JhNqgFkPE0wvRABnoHHmC4CgLA46nP73S3FHA?e=crHbgD"
          descripcion="Levantamiento de Suelos y Sedimentos. Contribución al Proyecto Prioritario Rescate del Lago de Texcoco"
          nombre="Memoria de suelos"
          imagen_lap="diagnostico_docs/memoria.jpg"
          imagen_cel="diagnostico_docs/memoria.jpg"
          :descargable="false"
        />
      </div>
    </div>

    <LayoutMapaDiagnostico />

    <div class="container m-y-1">
      <a
        class="btn btn-descarga a11y-simplificada-block"
        :href="publicPath + 'descargables/capas_rescate_lago_texcoco.zip'"
        download="capas_rescate_lago_texcoco"
      >
        Archivo de descarga<br />
        <small>
          Contiene 21 capas vectoriales con referencia espacial (GeoPackage) así
          como sus tablas en xlsx, csv y metadatos correspondientes.
        </small>
        <span class="icono icono-descargar"></span>
      </a>
      <div class="btn-vista-simplificada">
        <a
          class="btn-descarga-simplificado"
          :href="publicPath + 'descargables/capas_rescate_lago_texcoco.zip'"
          download="capas_rescate_lago_texcoco"
        >
          Archivo de descarga<br />
          <span class="icono icono-descargar"></span>
        </a>
        <small>
          Contiene 21 capas vectoriales con referencia espacial (GeoPackage) así
          como sus tablas en xlsx, csv y metadatos correspondientes.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutMapaDiagnostico from "@/components/mapa-diagnostico/LayoutMapaDiagnostico.vue";
import LinkPDF from "@/components/LinkPDF.vue";

export default {
  name: "Diagnostico",
  components: {
    LayoutMapaDiagnostico,
    LinkPDF,
  },
  data() {
    return {
      ficha_enfocada: 1,
      publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    if (document.getElementById("initial-loader")) {
      document.getElementById("initial-loader").remove();
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
  },
  beforeMount() {
    let is_mobile = false;
    /**Code from http://detectmobilebrowsers.com/ */
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        is_mobile = true;
    })(navigator.userAgent || navigator.vendor || window.opera);

    this.$store.commit("mapa/setMapaEnMobile", is_mobile);
    if (is_mobile) {
      this.$store.commit("mapa/setFaunaVerMalla", false);
    }
  },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($media-queries-limit, "mobile")) {
  .grid-descargas {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $gap * 2;
  }
}
.btn-descarga {
  display: block;
  border-radius: $gap * 0.5;
  width: 100%;
  padding: $gap $gap * 3 $gap $gap;
  position: relative;
  background: #141414;
  .icono {
    position: absolute;
    right: $gap;
    top: calc(50% - 15px);
    background: #fff;
    color: #000;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }
}
.btn-descarga:hover,
.btn-descarga:focus,
.btn-descarga:active,
.btn-descarga:visited {
  box-shadow: none;
  background: map-get($color-boton, "fondo");
  color: #fff;
  text-decoration: none;
}
.btn-vista-simplificada {
  display: none;
  .btn-descarga-simplificado {
    width: 22%;
    display: block;
    position: relative;
    .icono {
      position: absolute;
      top: 0;
      right: $gap;
    }
  }
}
</style>
